import React from 'react';
import { DatePicker } from 'antd';

export default function DateComponent({
  selectedDate,
  handleDateChange,
  id,
  isDisabled,
  style,
  allowClear = false,
}) {
  return (
    <>
      <DatePicker
        id={id}
        value={selectedDate}
        onChange={handleDateChange}
        format="YYYY-MM-DD"
        className="form-control"
        picker="date"
        allowClear={allowClear}
        disabled={isDisabled}
        style={{ ...style }}
      />
    </>
  );
}
